import React from 'react';
import './Info.scss'; // Import your SCSS file
import img from "../images/Info.jpeg"

const INFO = () => {
  return (
    <div className="info">
      <div className="title"><h1>How English Enclave <br></br> Came Into Existence :</h1></div>
      <div className="content">
        <div className="text-section">
          <p>As people fortunate enough to be born in the US and spend formative years immersed in a native English-speaking environment, my co-founder, Jayden and I have had the privilege of being surrounded by native speakers constantly. This experience inspired my co-founder and me to create a vibrant community dedicated to English for non-native speakers. Our mission is to provide an engaging and supportive space where native speakers help others enhance their English skills.
</p>
        </div>
        <div className="image-section">
          <img src={img} alt="Description" />
        </div>
      </div>
    </div>
  );
};

export default INFO;
